import {Component, EventEmitter, OnInit} from '@angular/core';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {__usernameOrEmail} from '../../../directives/validators/sts-conditional-email-validator.directive';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsTfaRegServiceService} from '../../../services/sts-tfa-reg-service.service';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';
import * as ph from 'libphonenumber-js';

@Component({
  selector: 'app-account-reg-validate-email',
  templateUrl: './account-reg-validate-email.component.html',
  styleUrls: ['./account-reg-validate-email.component.scss']
})
export class AccountRegValidateEmailComponent implements OnInit {

  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frm: FormGroup;
  public frm2: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public emailIsValid = true;
  public wantsToChangeEmail = false;
  public invalidCode = false;
  public tfaReference: string;
  private lastUnverifiedTfaEmail: string;
  message: StsA360NotificationTokenModel;
  isEmail:boolean=true;
  isEmailReadOnly: boolean = false;
  sentEmailMessage: string;
  sentPhoneTextMessage: string;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private cmsService: StsCmsService,
              private router: Router) {
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;
      this.isEmailReadOnly = this.tenantInfo.isEmailReadOnly;

      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          let isSelfRegFlow = portalStatus.isSelfRegFlow;
          if (!isSelfRegFlow) {
            console.log('User attempting to execute \'set username\' without permission! Redirecting to login.');
            this.router.navigateByUrl('/account/signin');
            return;
          }
          this.tfaReference = portalStatus.tfaReference;
          this.lastUnverifiedTfaEmail = portalStatus.lastUnverifiedTfaEmail;         
        });

    });

    this.frm2 = this.fb.group({
      code: new FormControl('',
        {
          validators: [ Validators.required] ,
          updateOn: 'blur'
        })
    }, { updateOn: 'submit' });

    this.frm = this.fb.group({
      email: new FormControl('',
        {
          validators: [
            (c: FormControl) => {
              if (!c.value) {
                return {
                  emailRequired: {
                    valid: false
                  }
                };
              }
              if (this.isEmail) {
                let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
                re = re.replace(/(^\\A)|(\\Z$)/g, '');
                this.emailIsValid = (new RegExp(re)).test(c.value);
                return (new RegExp(re)).test(c.value) ? null : {
                  validateEmail: {
                    valid: false
                  }
                };
              }
              else{
                try {
                  var phone = ph.parsePhoneNumberWithError(c.value, 'US')
                  return null;
                }
                catch (ex)
                {
                  console.log(ex.message);
                  return {
                    validateEmail: {
                      valid: false
                    }
                  }
                }
              }
            },
            __usernameOrEmail('email', () => this.getMode())] ,
          updateOn: 'blur'
        })
    }, { updateOn: 'submit' });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
    this.isEmail = this.message.PreferredChannel != "phone";    
    this.prepareConfirmationMessage(this.isEmail? this.message.Email : this.message.Phone);

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {
    this.frm2.controls['code'].updateValueAndValidity();
    this.frm.controls['email'].updateValueAndValidity();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.errors = [];
    this.triggerValidation('');
    if (this.wantsToChangeEmail) {
      this.wantsToChangeEmail = !this.wantsToChangeEmail;
    } else { this.router.navigateByUrl('/'); }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getMode(): string {
    return this.wantsToChangeEmail ? 'email' : 'code';
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  changeMode(): void {
    this.wantsToChangeEmail = !this.wantsToChangeEmail;
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  isInvalidCode(): boolean {
    return this.frm2.controls['code'].invalid &&
      (this.frm2.controls['code'].dirty || this.frm2.controls['code'].touched);
  }

  consolidateUsername(): void {
    if (!this.frm.controls['email'].value && this.lastUnverifiedTfaEmail) {
      if(this.isEmail)
        this.frm.controls['email'].setValue(this.lastUnverifiedTfaEmail);
      else
        this.frm.controls['email'].setValue(this.message.Phone);
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  resendEmail(): void {
    this.errors = [];
    this.consolidateUsername();
    this.triggerValidation('');

    this.tfa.sendValidationEmail(this.message.PreferredChannel, this.frm.controls['email'].value).subscribe(
      a => {
      if (a.success) {
        if (a['referenceNumber']) {
          this.tfaReference = a['referenceNumber'];
        }
        let e = new StsNotification();
        e.code = 'sts-verification-resent';
        e.level = StsNotificationType.Success;
        e.description = 'A new email was sent.';
        if(!this.isEmail)
        {
          e.description = 'A new SMS was sent.';
          e.code = 'sts-verification-resent-phone';
        }
        this.errors = [e];
      } else {
        let e = new StsNotification();
        e.code = 'sts-verification-resent-failed';
        e.level = StsNotificationType.Error;
        e.description = 'A new email was not sent.';
        if(!this.isEmail)
        {
          e.code = 'sts-verification-resent-failed-phone';
          e.description = 'A new SMS was not sent.';
        }
        this.errors = [e];
      }
    });
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmit(): void {
    // console.log(this.getMode(), this.emailIsValid);
    this.submitter.emit(false);
    this.consolidateUsername();
    this.triggerValidation('');
    if (this.frm.valid) {
      var phoneOrEmail = this.frm.controls['email'].value;
      try {
        if (!this.isEmail)
          phoneOrEmail = ph.parsePhoneNumberWithError(phoneOrEmail, 'US').number;
      }
      catch(ex)
      {
        console.log(ex);
      }
      this.submitter.emit(true);
      this.errors = [];  
         
      this.prepareConfirmationMessage(phoneOrEmail);

      this.tfa.sendValidationEmail(this.message.PreferredChannel, phoneOrEmail).subscribe(a => {
        if (a.success) {
          this.submitter.emit(false);
          let e = new StsNotification();
          e.code = 'sts-verification-resent';
          e.level = StsNotificationType.Success;
          e.description = 'A new email was sent.';
          if(!this.isEmail)
          {
            e.description = 'A new SMS was sent.';
            e.code = 'sts-verification-resent-phone';
          }
          this.errors = [e];
          this.changeMode();
        } else {
          this.submitter.emit(false);
          let e = new StsNotification();
          e.code = 'sts-correct-email-errors';
          e.level = StsNotificationType.Error;
          e.description = 'Submitted data has invalid format';
          this.errors = [e];
        }
      });
    } else {
      this.submitter.emit(false);
      let e = new StsNotification();
      e.code = this.isEmail ? 'sts-correct-email-errors' : 'sts-correct-phone-errors';

      e.level = StsNotificationType.Error;
      e.description = this.isEmail ? 'Submitted email has invalid format' : 'Submitted phone has invalid format. The correct format is<br>1234567890<br>123-456-7890<br>(123) 456-7890<br>123 456 7890<br>123.456.7890<br>+91 (123) 456-7890';
      this.errors = [e];
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmitCode(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    this.invalidCode = false;
    if (this.frm2.valid) {
      this.submitter.emit(true);
      this.errors = [];
      this.tfa.validateCode(this.frm2.controls['code'].value).subscribe(a => {
        this.submitter.emit(false);
        if (a.success) {
          this.router.navigateByUrl( '/account/password/new');
        } else {
          this.submitter.emit(false);
          let e = new StsNotification();
          e.code = 'sts-incorrect-verification-code-errors';
          e.level = StsNotificationType.Error;
          e.description = 'submitted data contains errors';
          this.errors = [e];
        }
      });
    } else {
      this.submitter.emit(false);
      let e = new StsNotification();
      e.code = 'sts-incorrect-verification-code-errors';
      e.level = StsNotificationType.Error;
      e.description = 'submitted data contains errors';
      this.errors = [e];
    }
  }

  private prepareConfirmationMessage(address: string) {
    this.cmsService.getText('sts-signup-step-3-validate-body-section').subscribe(res => {
      let message = res
        ? res
        : `We have sent an email to {{emailAddress}}. Please enter the verification code sent to you in the provided field below.`;

      this.sentEmailMessage = message.replace('{{emailAddress}}', this.maskEmail(address));
    });

    this.cmsService.getText('sts-signup-step-3-validate-body-section-phone').subscribe(res => {
      let message = res
        ? res
        : `We have sent a text to {{phoneNumber}}. Please enter the verification code sent to you in the provided field below.`;

      this.sentPhoneTextMessage = message.replace('{{phoneNumber}}', this.maskPhone(address));
    });
  }

  private maskPhone(phone: string): string {
    if (phone == undefined || phone.length == 0) {
      return '';
    }

    return phone.replace(/\d(?!\d{0,3}$)/g, 'x');
  }

  private maskEmail(email: string): string {
    if (email == undefined || email.length == 0)
    {
      return '';
    }

    let atIndex = email.indexOf('@');
    if (atIndex < 2)
    {
      return '';
    }

    let toReplace = email.substring(1, atIndex - 1);
    if (toReplace.length < 1)
    {
      return '';
    }

    let replaceWith = '';
    for (let i = 0; i < toReplace.length; i++)
    {
      replaceWith = replaceWith + 'x';
    }

    return email.replace(toReplace, replaceWith);
  }

}
